import * as React from "react";
import type { InputCurrencyProps } from "./InputCurrencyProps";
import { Input } from "@/components/ui/Input";
import { clsx } from "clsx";
import classes from "./InputCurrency.module.scss";
import { getCurrencySymbol } from "@/utils/formatters";

export const InputCurrency = (props: InputCurrencyProps) => {
  const {
    currencySymbol = getCurrencySymbol(),
    className,
    onPaste,
    onChange,
    ...inputProps
  } = props;

  const handleChangeValue = (value: string, preserveNegative = false) => {
    const sanitized = value.replace(
      preserveNegative ? /[^0-9.-]/g : /[^0-9.]/g,
      "",
    );
    onChange?.(sanitized);
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    onPaste?.(e);
    e.preventDefault();

    const pastedText = e.clipboardData.getData("text");
    handleChangeValue(pastedText, true);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleChangeValue(e.target.value);
  };

  return (
    <label className={clsx(classes.inputCurrency, className)}>
      <span className={classes.inputCurrency__prefix} data-currency-symbol>
        {currencySymbol}
      </span>
      <div className={classes.inputCurrency__input}>
        <Input
          type="number"
          onChange={handleChange}
          onPaste={handlePaste}
          {...inputProps}
        />
      </div>
    </label>
  );
};
